/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type LeaveApprovalPayload = {
  leaveId: string;
  status: "approved" | "rejected" | "pending" | string;
};

export type LeaveApprovalResponse = {
  success: boolean;
  message?: string;
  data?: any;
};

const approveLeave = async (payload: LeaveApprovalPayload) => {
  const res = await customAxios.put<LeaveApprovalResponse>(
    "/leaves/leave-approval",
    payload
  );
  return res.data;
};

export const useApproveLeave = () => {
  const queryClient = useQueryClient();

  return useMutation<LeaveApprovalResponse, AxiosError, LeaveApprovalPayload>(
    (payload: LeaveApprovalPayload) => approveLeave(payload),
    {
      onSuccess: (data, variables) => {
        showNotification({
          title: "Leave Updated",
          message: `Leave status updated`,
          color: "green",
        });

        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey?.[0] === "leaveRequestsAdmin",
        });
      },
      onError: (error: AxiosError) => {
        showNotification({
          title: "Leave Update Failed",
          message: "Failed to update leave status",
          color: "red",
        });
      },
      retry: 1,
    }
  );
};
